import React from 'react';
import { BwjGrid, Row, Col } from '../../../../framework/components/bwj-layout';
import { Spacing } from '../../../../framework/components/bwj-layout/styles';
import * as formService from '../../form-services/customer-editor';
import { BwjLabelField } from '../../../../framework/components/bwj-label-field';
import { ICustomer } from '../../../../entities-generated/common/customer';

interface ICustomerViewerProps {
  customer: ICustomer;
}

export const CustomerViewer: React.FunctionComponent<ICustomerViewerProps> = (props) => {
  const { customer } = props;

  return (
    <BwjGrid>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12} large={8}>
          <BwjLabelField
            id={formService.name.id}
            label={formService.name.description}
            value={customer.name}
            noBorder={true}
          />
        </Col>
        <Col small={12} large={4}>
          <BwjLabelField
            id={formService.firstName.id}
            label={formService.firstName.description}
            value={customer.firstName}
            noBorder={true}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={3} large={2}>
          <BwjLabelField
            id={formService.houseNumber.id}
            label={formService.houseNumber.description}
            value={customer.houseNumber}
            noBorder={true}
          />
        </Col>
        <Col small={9} large={10}>
          <BwjLabelField
            id={formService.streetName.id}
            label={formService.streetName.description}
            value={customer.streetName}
            noBorder={true}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12} large={8}>
          <BwjLabelField
            id={formService.city.id}
            label={formService.city.description}
            value={customer.city}
            noBorder={true}
          />
        </Col>
        <Col small={3} large={1}>
          <BwjLabelField
            id={formService.state.id}
            label={formService.state.description}
            value={customer.state}
            noBorder={true}
          />
        </Col>
        <Col small={9} large={3}>
          <BwjLabelField
            id={formService.zipCode.id}
            label={formService.zipCode.description}
            value={customer.zipCode}
            noBorder={true}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12} large={6}>
          <BwjLabelField
            id={formService.email.id}
            label={formService.email.description}
            value={customer.email}
            noBorder={true}
          />
        </Col>
        <Col small={12} large={3}>
          <BwjLabelField
            id={formService.phonePrimary.id}
            label={formService.phonePrimary.description}
            value={customer.phonePrimary}
            noBorder={true}
          />
        </Col>
        <Col small={12} large={3}>
          <BwjLabelField
            id={formService.phoneSecondary.id}
            label={formService.phoneSecondary.description}
            value={customer.phoneSecondary}
            noBorder={true}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12}>
          <BwjLabelField
            id={formService.notes.id}
            label={formService.notes.description}
            value={customer.notes}
            noBorder={true}
            multiline={true}
          />
        </Col>
      </Row>
      <Row bottomSpacing={Spacing.Large}>
        <Col small={12} large={6}>
          <BwjLabelField
            id={formService.providedName.id}
            label={formService.providedName.description}
            value={customer.providedName}
            noBorder={true}
          />
        </Col>
        <Col small={12} large={6}>
          <BwjLabelField
            id={formService.paymentProcessorCustomerId.id}
            label={formService.paymentProcessorCustomerId.description}
            value={customer.paymentProcessorCustomerId}
            noBorder={true}
          />
        </Col>
      </Row>
    </BwjGrid>
  );
};